export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-mobile-76423c790f0b58d6c0cf4ccd8927e6ab.svg";